import { BehaviorSubject } from "rxjs";
import { ServiceResult } from "../data.types";

interface Message {
  channel: string;
  payload: ServiceResult;
}

export class LiveDataService {
  client!: WebSocket | undefined;
  dataBus = new BehaviorSubject<ServiceResult>({
    error: new Error("Client not connected!"),
  });
  timelineDataBus = new BehaviorSubject<ServiceResult>({
    error: new Error("Waiting for initial data..."),
  });
  dsnDataBus = new BehaviorSubject<ServiceResult>({
    error: new Error("Waiting for initial data..."),
  });

  constructor() {
    this.connect();
  }

  connect() {
    this.client = new WebSocket(
      "wss://data.mahetec.info/nodered/nasa/artemis/ws",
    );
    this.client.onmessage = (message: MessageEvent<string>) => {
      const data: Message = JSON.parse(message.data);
      switch (data.channel) {
        case "default":
          this.dataBus.next(data.payload);
          break;
        case "timeline":
          this.timelineDataBus.next(data.payload);
          break;
        case "dsn":
          this.dsnDataBus.next(data.payload);
          break;
      }
    };
    this.client.onclose = () => {
      console.log("Client closed");
      setTimeout(() => {
        if (this.client) this.connect();
      }, 15000);
    };
  }

  disconnect() {
    if (this.client) this.client.close();
    this.client = undefined;
  }
}
